export const themes = {
    incred: {
      primary: "#F15424",
    },
  };
  